export const MAX_NFT_SELECTABLE = 10
export const MAX_POOL_SELECTABLE = 2
